module.exports = __webpack_public_path__ + "img/calling-animation.96900d5c.gif";